const STORAGE_KEY = "shop-wishlist";

export function getWishlist(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function toggleWishlist(id: number): boolean {
  const list = getWishlist();
  const index = list.indexOf(id);
  if (index >= 0) {
    list.splice(index, 1);
  } else {
    list.push(id);
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  window.dispatchEvent(new CustomEvent("wishlist-change"));
  return index < 0;
}

export function isInWishlist(id: number): boolean {
  return getWishlist().includes(id);
}
